import { FC } from "react";

import { homeAboutContent } from "./content";
import HomeAboutRichText from "./HomeAboutRichText";

type HomeAboutStoryBodyProps = {
  /** Body text size — desktop uses slightly larger copy. */
  bodyClassName?: string;
};

/** Renders the HomeCook Story narrative paragraphs, optional personal layer, and belief blockquote. */
export const HomeAboutStoryBody: FC<HomeAboutStoryBodyProps> = ({
  bodyClassName = "text-[16px] font-open-sans text-text-0 leading-[1.7]",
}) => {
  const { paragraphs, belief, personalStory } = homeAboutContent;
  const inlinePersonal = personalStory?.inlineParagraph;
  const titledPersonal = personalStory?.title && personalStory?.paragraphs?.length;

  return (
    <div className="max-w-prose">
      {paragraphs.map((paragraph, index) => (
        <p
          key={index}
          className={`${bodyClassName} ${
            index < paragraphs.length - 1 ? "mb-4" : inlinePersonal ? "mb-4" : "mb-5"
          }`}
        >
          <HomeAboutRichText segments={paragraph} />
        </p>
      ))}

      {inlinePersonal && (
        <p className={`${bodyClassName} mb-5 text-text-300`}>
          <HomeAboutRichText segments={inlinePersonal} />
        </p>
      )}

      <div className="mt-1 border-t border-[#E9E9E9] pt-4">
        <blockquote className="mt-0 border-l-[3px] border-primaryDark-400 pl-4">
          <p className={`${bodyClassName} text-[15px] xl:text-[16px] leading-[1.65] text-primaryDark-0`}>
            <span className="font-semibold">{belief.lead}</span>{" "}
            <HomeAboutRichText segments={belief.body} />
          </p>
        </blockquote>
      </div>

      {titledPersonal && (
        <div className="mt-6 pt-5 border-t border-[#E9E9E9]">
          <p className="mb-3 text-[14px] font-open-sans font-bold text-primaryDark-0">
            {personalStory.title}
          </p>
          {personalStory.paragraphs?.map((paragraph, index) => (
            <p
              key={index}
              className={`${bodyClassName} ${
                index < (personalStory.paragraphs?.length ?? 0) - 1 ? "mb-4" : "mb-0"
              }`}
            >
              <HomeAboutRichText segments={paragraph} />
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default HomeAboutStoryBody;
